export const ACTION_REQUEST = 'FETCH_SITECONFIG_REQUEST';
export const ACTION_SUCCESS = 'FETCH_SITECONFIG_SUCCESS';
export const ACTION_ERROR = 'FETCH_SITECONFIG_ERROR';
